// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"e42d5c22","134":"7e70d66f","145":"96bd2a85","343":"88442420","443":"9320f207","453":"f15fcc03","498":"175778ab","546":"a875c354","658":"2ff55f7c","662":"88838b7f","769":"06f2b60b","951":"4bb28e8e"}[chunkId] + ".chunk.js";
};